<template>
  <div ref="gondola__container" class="gondola__container">
    <div
      class="gondola"
      :class="`gondola-${index}`"
      :style="{
        left: leftPos,
        bottom: `${siblingHeight}px`,
        width: `${gondolaSize}px`,
        height: `${gondolaSize * 0.75}px`,
      }"
    >
      <!-- transform: `translateY(${shiftY}px)`, -->
      <!-- <div
        class="f-ui-2-bold"
        :style="{ transform: `translateY(${gondolaSize * 0.75}px)` }"
      >
        {{ value }}
      </div> -->
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  data() {
    return {
      cwidth: 0,
      cheight: 0,
      gondolaSize: 20,
      siblingMargin: 15,
      siblingHeight: 0,
    };
  },
  props: {
    scenario: {
      type: String,
    },
    value: {
      type: Number,
    },
    index: {
      type: Number,
    },
    maxSize: {
      type: Number,
    },
  },
  mounted() {
    let container = this.$refs.gondola__container;
    this.siblingHeight =
      this.$parent.$parent.$children[1].$el.offsetHeight + this.siblingMargin;
    this.cwidth = container.clientWidth;
    this.cheight = container.clientHeight - this.siblingHeight;
    const { index, shiftY } = this;
    gsap.to(`.gondola-${index}`, {
      transform: `translateY(${shiftY}px)`,
      duration: 2,
      delay: 0.25,
    });
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      let container = this.$refs.gondola__container;
      this.siblingHeight =
        this.$parent.$parent.$children[1].$el.offsetHeight + this.siblingMargin;
      this.cwidth = container.clientWidth;
      this.cheight = container.clientHeight - this.siblingHeight;
    },
  },
  computed: {
    leftPos() {
      const { cwidth, index, gondolaSize } = this;
      let col = cwidth / 8;
      let offset = gondolaSize / 2;
      return `${col * (2 * index + 1) - offset}px`;
    },
    shiftY() {
      const { cheight, value, gondolaSize } = this;
      let max = cheight * 0.3;
      let row = max / 5;
      let offset = (gondolaSize * 0.75) / 2;
      return -(row * (value + 1) - offset);
    },
  },
};
</script>

<style scoped>
.gondola__container {
  width: 100%;
  height: 100%;
  position: absolute;
}
.gondola {
  position: absolute;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gondola::before {
  content: "";
  background-color: #646464;
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  border-radius: 5px;
}
.gondola::after {
  content: "";
  background-color: #d8d4c0;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 15% 100%);
}
</style>
